import { render, staticRenderFns } from "./UserAvatarView.vue?vue&type=template&id=f091c7f8&scoped=true&"
import script from "./UserAvatarView.vue?vue&type=script&lang=js&"
export * from "./UserAvatarView.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarView.vue?vue&type=style&index=0&id=f091c7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f091c7f8",
  null
  
)

export default component.exports